import { MetadataFieldRendererProps } from '@/asset/components/metadata/field-renderer';
import { MINIMUM_DATE } from '@/constants/date-shortcut';
import { DatePicker } from '@mui/x-date-pickers-pro';
import { DateTime } from 'luxon';
import { FieldValues, useFormContext, useWatch } from 'react-hook-form';

/**
 * Renders a date field in the metadata form.
 *
 * IMPORTANT: This component must be wrapped in a FormProvider from react-hook-form.
 */
export function DateFieldRenderer(props: MetadataFieldRendererProps) {
  const { metadata, setValue, error, fieldIndex } = props;
  const { control } = useFormContext<FieldValues>();
  const value = useWatch({
    control,
    name: `metadata.${fieldIndex}.value`,
  });
  return (
    <DatePicker
      label={metadata.field.label}
      views={['year', 'month', 'day']}
      value={value ? DateTime.fromFormat(String(value), 'yyyy-MM-dd') : null}
      onChange={(newValue: DateTime | null) => {
        const formattedValue = newValue
          ? newValue.toFormat('yyyy-MM-dd')
          : null;
        setValue(formattedValue);
      }}
      minDate={MINIMUM_DATE}
      slotProps={{
        textField: {
          fullWidth: true,
          size: 'small',
          error: !!error,
          helperText: error?.message,
        },
        actionBar: {
          actions: ['clear', 'accept'],
        },
      }}
    />
  );
}
